import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { IFormOptions } from "@interfaces/index";
import { Subject } from "rxjs";
import { takeUntil, debounceTime, distinctUntilChanged } from "rxjs/operators";

@Component({
  selector: "aff-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"],
})
export class FilterComponent implements OnInit, OnDestroy {
  @ViewChild('inputElement', { static: true }) inputElement: ElementRef;
  @Output() outPutKeword = new EventEmitter<string>();
  @Output() onFilterToggle: EventEmitter<boolean> = new EventEmitter;
  @Input() searchTitle: string = "";
  @Input() hasFilter: boolean = true;
  @Input() hasSearch: boolean = true;
  @Input() showSearch: boolean = true;

  showFilter: boolean = false;
  keyword = new FormControl(null);

  unsubscribe$ = new Subject<void>();
  seachInfo:any;
  constructor() {}

  ngOnInit(): void {
    this.keyword.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((keyword) => this.outPutKeword.emit(keyword));
  }

  onToggleFilter(): void {
    this.showFilter = !this.showFilter;
    this.onFilterToggle.emit(this.showFilter);
  }

  onSearch(inputValue): void {
    const options = {
      value:  inputValue.target.value,
      name: 'keyword'
    }
    this.seachInfo = options;
    this.keyword.patchValue(this.seachInfo.value);
  }
  onChange(inputValue) {
    const options = {
      value:  inputValue.target.value,
      name: 'keyword'
    }
    this.seachInfo = options;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
